'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactHotLoader = require('react-hot-loader');

var _buildSagas = require('./buildSagas');

var _buildSagas2 = _interopRequireDefault(_buildSagas);

var _createStore = require('./createStore');

var _createStore2 = _interopRequireDefault(_createStore);

var _middleware = require('./middleware');

require('./main.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Starts a sitebase container.
 * @param {RenderParamsType} params An object with the function parameters
 * @param {Reac.Element<*>} params.App The root application component
 * @param {Map<*, *>|string} [params.initialState] The application initial state. Default: Empty object
 * @param {ClientMiddlewareType} [params.middleware] An array of middlewares to be applied to the store. Defaults to an
 * empty array
 * @param {SagaType} [params.sagas] An array of sagas to be run on application start. Each saga is forked. Defaults to
 * an empty array
 * information
 * @param {AppReducersMapType} [params.reducers] key value pair of reducers where the key is the state leaf that the
 * reducer will be responsible for. Defaults to an empty object
 * @returns {Store} Your site base powered redux store
 * @public
 */


/**
 * The render function parameters
 */
var render = function render(_ref) {
    var App = _ref.App,
        initialState = _ref.initialState,
        _ref$middleware = _ref.middleware,
        middleware = _ref$middleware === undefined ? [] : _ref$middleware,
        _ref$sagas = _ref.sagas,
        sagas = _ref$sagas === undefined ? [] : _ref$sagas,
        _ref$reducers = _ref.reducers,
        reducers = _ref$reducers === undefined ? {} : _ref$reducers,
        _ref$targetId = _ref.targetId,
        targetId = _ref$targetId === undefined ? 'app' : _ref$targetId;

    var store = (0, _createStore2.default)(reducers, initialState, middleware);
    _middleware.sagaMiddleware.run((0, _buildSagas2.default)(sagas, function (target) {
        return target.browser;
    }));

    (0, _reactDom.render)((0, _jsx3.default)(_reactHotLoader.AppContainer, {}, void 0, (0, _jsx3.default)(_reactRedux.Provider, {
        store: store
    }, void 0, (0, _jsx3.default)(App, {}))), document.getElementById(targetId));

    if (process.env.NODE_ENV === 'development') {
        if (module.hot) {
            // $FlowIssue Enable Webpack hot module replacement for reducers
            module.hot.accept();
        }
    }

    return store;
};

// css


// types

exports.default = render;
//# sourceMappingURL=render.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/render.js
// module id = 536
// module chunks = 0